
export class Bank{
    id:string
    nameEn:string
    nameKh:string
    accountName:string
    accountNo:string
    qrImageUrl:string
}